import * as React from 'react';

import MoreButton from 'components/buttons/more-button/MoreButton';
import { withContextMenu } from 'components/context-menu/ContextMenuHOC';

import { insertIf } from 'utils/list';
import { __t, applyTranslations } from 'utils/language';

import type { ContextMenuItem as ContextMenuItemType, ListContextMenu, ProposalCreatorProfile } from 'types';

import './proposal-tile-context-menu.scss';

const ContextMenu = withContextMenu(MoreButton, {
  position: 'bottom',
  forceEventPropagation: true
});

applyTranslations(require('./proposal-tile-context-menu.i18n.json'));

type Props = {
  creatorProfile: ProposalCreatorProfile,
  contextMenuProps?: ListContextMenu,
  canDelete?: boolean,
  onDelete?: () => void
};

const ProposalContextMenu: React.FunctionComponent<Props> = (
  {
    canDelete,
    onDelete,
    creatorProfile,
    contextMenuProps
  }: Props
) => {
  const menuItems: Array<ContextMenuItemType> = [
    ...insertIf(canDelete, {
      name: 'delete-influencer',
      text: __t('proposal_tile_context_menu.delete_influencer'),
      onClick: onDelete,
      meta: {
        list: contextMenuProps
      }
    }),
    {
      type: 'lists',
      name: 'lists',
      text: __t('proposal_tile_context_menu.add_influencer'),
      meta: {
        influencer: creatorProfile,
        list: contextMenuProps
      }
    }
  ];

  return (
    <div className="proposal-tile-context-menu">
      <ContextMenu
        contextMenuProps={{
          items: menuItems
        }}
        width={40}
        iconWidth={6}
        iconHeight={24}
      />
    </div>
  );
};

export default ProposalContextMenu;
